import { Badge, Dropdown, Menu, Avatar } from "antd";
import { BellOutlined } from "@ant-design/icons";
import { useState } from "react";
import { getNotifications } from "./actions/notificationsService";
import NotificationItem from "./NotificationItem";

const NotificationsDropdown = () => {
  const [notifications, setNotifications] = useState([]);

  const handleVisibleChange = async (visible) => {
    if (visible) {
      const allNotifications = await getNotifications();
      setNotifications(allNotifications);
    }
  };

  const menu = (
    <Menu className="notification-dropdown">
      {notifications.length > 0 ? (
        <>
          <span>Notifications</span>
          <div className="notification-scroll-container">
            {notifications.map((notification, index) => (
              <NotificationItem keyProp={index} notification={notification} />
            ))}
          </div>
        </>
      ) : (
        <Menu.Item key="no-data">No Notifications</Menu.Item>
      )}
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={["click"]}
      onVisibleChange={handleVisibleChange}
    >
      <Badge count={notifications.length}>
        <Avatar shape="circle" size={34}>
          <BellOutlined />
        </Avatar>
      </Badge>
    </Dropdown>
  );
};

export default NotificationsDropdown;
